import { useCallback } from "react";
import { useProjects } from "../../../projects/projectContext";
import { useLoad, type LoadHandle } from "../../../shared/loading/useLoad";
import { loadProcess, type LoadedProcess } from "./processCatalogue";
import { projectProcessReader } from "./projectProcessReader";

/** Where a run reads its project items: the Thread's project at its bound content commit (F103). */
export interface ProcessScope {
  readonly projectId: string;
  readonly commit: string | null;
}

/**
 * A Workflow version and everything the view can open from it. Floating artifact reads
 * resolve to the latest version in the chosen project, or as a Thread's run reads them
 * (`scope`); without a project they stay unresolved.
 */
export function useProcess(reference: string, scope: ProcessScope | null = null): LoadHandle<LoadedProcess> {
  const selectedProjectId = useProjects().selectedProjectId;
  const projectId = scope?.projectId ?? selectedProjectId;
  const commit = scope?.commit ?? null;
  const load = useCallback((signal: AbortSignal) => loadProcess(reference, projectProcessReader(projectId, signal, commit)), [reference, projectId, commit]);
  return useLoad(load);
}
